import { MISSION_NATURE } from 'containers/ExpertExpertise/ConcernedExpertise/constants';
import { get } from 'lodash';
import messages from 'containers/ExpertAssignedMissions/messages';

/* istanbul ignore next */
export const extractStatusExpert = (mission: any, connectedExpert: any) => {
  const statusExpert = get(mission, 'assignedExperts', []).find(
    (element: any) => String(element.expertCode) === String(connectedExpert),
  );
  return get(statusExpert, 'status');
};

export const renderNatureMission = (nature: string) => {
  if (nature === MISSION_NATURE.JUDICIARY) {
    return messages.judiciaryNatureTitle;
  } else {
    return messages.transactionNatureTitle;
  }
};
